<cft-dialog [title]="props.title">
  <cft-dialog-content class="pb-md">
    <p class="text-sm" [innerHTML]="props.info"></p>
  </cft-dialog-content>
</cft-dialog>
